import { FC, useState, createContext, useContext } from 'react'
import {
  QueryState,
  QueryRequestContextProps,
  initialQueryRequest,
  WithChildren,
} from '../../../../../_metronic/helpers'
import moment from 'moment/moment'

const QueryRequestContext = createContext<QueryRequestContextProps>(initialQueryRequest)

type WithDefaultStatus = {
  statusId?: number
}

const QueryRequestProvider: FC<WithChildren & WithDefaultStatus> = ({ children, statusId }) => {
  const [state, setState] = useState<QueryState>({
    ...initialQueryRequest.state,
    status: statusId,
  })

  const updateState = (updates: Partial<QueryState>) => {
    const updatedState = { ...state, ...updates } as QueryState
    setState(updatedState)
  }

  return (
    <QueryRequestContext.Provider value={{ state, updateState }}>
      {children}
    </QueryRequestContext.Provider>
  )
}

const useQueryRequest = () => useContext(QueryRequestContext)
export { QueryRequestProvider, useQueryRequest }
